import { render, staticRenderFns } from "./GprHeader.vue?vue&type=template&id=f277412a"
import script from "./GprHeader.vue?vue&type=script&lang=js"
export * from "./GprHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports